/* Keep native dialog focus/returnValue semantics, allowing Listen's 320ms exit.
   Decorate only SS instances; never change the browser's dialog prototype. */
(() => {
  const selector='dialog[data-suggestive-sales="modal"],dialog[data-suggestive-sales="product-dialog"]';
  const bound=new WeakSet();
  const modalSelector=selector+',.mwy-quick-add-modal,#mwy-listen-modal';
  const backdrop=document.createElement('div');
  backdrop.id='mwy-shared-modal-backdrop';backdrop.setAttribute('aria-hidden','true');
  document.body.append(backdrop);document.body.classList.add('mwy-shared-modal-backdrop');
  let backdropFrame=0,backdropClose;
  function refreshBackdrop() {
    backdropFrame=0;
    const active=document.querySelector(selector.split(',').map(s=>s+'[open]').join(',')+',.mwy-quick-add-modal.modal--is-active,.mwy-quick-add-modal.modal--is-closing,#mwy-listen-modal:not([hidden])');
    if(active){clearTimeout(backdropClose);backdropClose=null;if(!backdrop.classList.contains('is-open'))backdrop.classList.add('is-open');}
    else if(!backdropClose && backdrop.classList.contains('is-open'))backdropClose=setTimeout(()=>{backdropClose=null;backdrop.classList.remove('is-open');},180);
  }
  function scheduleBackdrop(){if(!backdropFrame)backdropFrame=requestAnimationFrame(refreshBackdrop);}
  function bind(dialog) {
    if(bound.has(dialog))return;
    bound.add(dialog);
    const close=dialog.close.bind(dialog),show=dialog.showModal.bind(dialog);
    let timer;
    dialog.close=function(value) {
      if(!dialog.open || matchMedia('(prefers-reduced-motion:reduce)').matches) {
        clearTimeout(timer);dialog.removeAttribute('data-mwy-closing');close(value);return;
      }
      if(timer)return;
      dialog.setAttribute('data-mwy-closing','');
      timer=setTimeout(()=>{timer=null;close(value);dialog.removeAttribute('data-mwy-closing');},320);
    };
    dialog.showModal=function() {
      if(timer){clearTimeout(timer);timer=null;dialog.removeAttribute('data-mwy-closing');}
      if(!dialog.open)show();
    };
    dialog.addEventListener('cancel',event=>{event.preventDefault();dialog.close();});
  }
  function scan(root) {if(root.matches?.(selector))bind(root);root.querySelectorAll?.(selector).forEach(bind);}
  scan(document);
  // Tab/header class changes do not affect the modal backdrop.
  new MutationObserver(records=>{
    let changed=false;
    records.forEach(record=>{
      if(record.type==='attributes') {
        if(record.target.matches(modalSelector))changed=true;
        return;
      }
      record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);});
      if([...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1 &&
        (node.matches(modalSelector)||node.querySelector(modalSelector))))changed=true;
    });
    if(changed)scheduleBackdrop();
  }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','open','hidden']});
  refreshBackdrop();
})();
